// extracted by mini-css-extract-plugin
export default {"addToBasket":"AddToBasketBtn_addToBasket__G1v7Q","card":"AddToBasketBtn_card__5v8jS","content":"AddToBasketBtn_content__eBia9","footer":"AddToBasketBtn_footer__nfb62"};